var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTextBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.061 9.94l-7-7A1.501 1.501 0 0019 2.5H7A2.5 2.5 0 004.5 5v22A2.5 2.5 0 007 29.5h18a2.5 2.5 0 002.5-2.5V11a1.5 1.5 0 00-.439-1.06zM20 7.125L22.875 10H20V7.125zM7.5 26.5v-21H17v6a1.5 1.5 0 001.5 1.5h6v13.5h-17zm14-10A1.5 1.5 0 0120 18h-8a1.5 1.5 0 110-3h8a1.5 1.5 0 011.5 1.5zm0 5A1.5 1.5 0 0120 23h-8a1.5 1.5 0 110-3h8a1.5 1.5 0 011.5 1.5z"
  })));
}
export default SvgFileTextBold;